<script setup>
import { computed } from 'vue'
import { state } from '@/components/Ajuda/Montador/composables/useBuilderState'

// Formatação simples "X,YY m"
function toBR(n, digs = 2) {
  const v = Number(n)
  return Number.isFinite(v) ? v.toFixed(digs).replace('.', ',') : '—'
}
function fmtM(n, digs = 2) { return n == null ? '—' : `${toBR(n, digs)} m` }

// Distância entre 2 pontos de medição (em metros)
const measureDistance = computed(() => {
  const pts = state.tools?.measurePts || []
  if (pts.length !== 2) return 0
  const dx = pts[1].x - pts[0].x
  const dy = pts[1].y - pts[0].y
  return Math.hypot(dx, dy)
})

function toggleMeasure() {
  state.tools.measureActive = !state.tools.measureActive
  if (!state.tools.measureActive) state.tools.measurePts = []
}

function clearMeasure() {
  state.tools.measurePts = []
}
</script>

<template>
  <div class="section">
    <label class="label">Medição</label>
    <div class="row two">
      <button class="btn"
              :class="{ active: state.tools.measureActive }"
              @click="toggleMeasure">
        {{ state.tools.measureActive ? 'Medindo (Esc para sair)' : 'Ativar medição' }}
      </button>
      <button class="btn"
              @click="clearMeasure"
              :disabled="!(state.tools.measurePts && state.tools.measurePts.length)">
        Limpar
      </button>
    </div>
    <div class="hint">
      Clique em dois pontos no mapa quando a medição estiver ativa.
      <br>
      Distância: <strong>{{ fmtM(measureDistance) }}</strong>
    </div>
  </div>
</template>

<style scoped>
.label { margin: 0 0 6px; font-size: 13px; color: #9eb3ff; }
</style>
